import { Textarea } from '@/components/ui/daisy';
import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';
import { QuestionTypeEnum } from '@/models/Question';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { useWritingAnswerView } from '@/components/question/view/typologies/writing/useWritingAnswerView';

export function WritingAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.WRITING>,
) {
  const { handleChange, disabled } = useWritingAnswerView(props);
  const { t } = useTranslation('translation', { keyPrefix: 'questionView' });

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <Textarea
        value={props.value ?? ''}
        onChange={e => handleChange(e.target.value)}
        placeholder={t('typeAnswer')}
        className={twMerge(
          'w-full min-h-24 px-5 py-1 border border-dashed border-secondary content-center',
          disabled && 'pointer-events-none',
        )}
      />
    </div>
  );
}
